<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#229;&#175;&#188;&#232;&#136;&#170;&#230;&#160;&#143;/&#231;&#174;&#173;&#229;&#164;&#180;"
      clip-path="url(#clip0_4205_91760)">
      <path id="Vector"
        d="M12.8541 9.35375L8.35414 13.8538C8.30771 13.9002 8.25256 13.9371 8.19186 13.9623C8.13116 13.9874 8.0661 14.0004 8.00039 14.0004C7.93469 14.0004 7.86962 13.9874 7.80892 13.9623C7.74822 13.9371 7.69308 13.9002 7.64664 13.8538L3.14664 9.35375C3.07664 9.28382 3.02895 9.1947 3.00963 9.09765C2.9903 9.00061 3.00021 8.90002 3.03808 8.80861C3.07596 8.71719 3.14011 8.63908 3.2224 8.58414C3.3047 8.5292 3.40145 8.49992 3.50039 8.5H7.50039V2.5C7.50039 2.36739 7.55307 2.24021 7.64684 2.14645C7.74061 2.05268 7.86779 2 8.00039 2C8.133 2 8.26018 2.05268 8.35395 2.14645C8.44772 2.24021 8.50039 2.36739 8.50039 2.5V8.5H12.5004C12.5993 8.49992 12.6961 8.5292 12.7784 8.58414C12.8607 8.63908 12.9248 8.71719 12.9627 8.80861C13.0006 8.90002 13.0105 9.00061 12.9912 9.09765C12.9718 9.1947 12.9241 9.28382 12.8541 9.35375Z"
        fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_4205_91760">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'icon-next-arrow',
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>